// Toast utility that replaces react-hot-toast
// This provides a compatible API while using our new morphing toast system

let toastContext = null;

// Set the context reference (called by ToastProvider)
export const setToastContext = (context) => {
  toastContext = context;
  window.toastContext = context; // Global fallback
};

// Toast API that mimics react-hot-toast with size support
const toast = {
  success: (message, options = {}) => {
    if (toastContext) {
      const size = options.size || 'normal';
      const duration = options.duration;
      toastContext.success(message, size, duration);
    } else {
      console.warn('Toast context not available:', message);
    }
  },
  
  error: (message, options = {}) => {
    if (toastContext) {
      const size = options.size || 'normal';
      const duration = options.duration;
      toastContext.error(message, size, duration);
    } else {
      console.warn('Toast context not available:', message);
    }
  },
  
  warning: (message, options = {}) => {
    if (toastContext) {
      const size = options.size || 'normal';
      const duration = options.duration;
      toastContext.warning(message, size, duration);
    } else {
      console.warn('Toast context not available:', message);
    }
  },
  
  info: (message, options = {}) => {
    if (toastContext) {
      const size = options.size || 'normal';
      const duration = options.duration;
      toastContext.info(message, size, duration);
    } else {
      console.warn('Toast context not available:', message);
    }
  },

  // Special methods for different sizes
  small: {
    success: (message) => toast.success(message, { size: 'small' }),
    error: (message) => toast.error(message, { size: 'small' }),
    warning: (message) => toast.warning(message, { size: 'small' }),
    info: (message) => toast.info(message, { size: 'small' })
  },

  // Aliases for compatibility
  warn: function(message, options = {}) {
    return this.warning(message, options);
  }
};

export default toast;